import React, { useEffect, useState } from 'react';
import Header from '../../dashboard/header';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import { FaTools } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom'; // Ensure this is imported
import useAuth from '../../dashboard/useAuth';
import axios from 'axios';

const Ajouter_eco = ({ titre }) => {
    useAuth();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const navigate = useNavigate();
    const user_id = localStorage.getItem('user_id');
        const [alert, setAlert] = useState({ message: '', type: '' });

    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Ajouter Eco";
        }
    }, [user_id]);


    const handleSubmit = async (event) => {
        event.preventDefault();

        const formData = {
            fr: {
                titre: event.target.titre_fr.value,
                description: event.target.description_fr.value,
                ordre: event.target.ordre_fr.value,
            },
            en: {
                titre: event.target.titre_en.value,
                description: event.target.description_en.value,
                ordre: event.target.ordre_en.value,
            }
        };

        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/ajouter-eco/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Erreur:', errorData);
                showAlert(errorData.error, 'danger')
            } else {
                const data = await response.json();
                console.log('Succès:', data);
                console.log('Redirection vers la liste des ecos');
                navigate(`/Liste-eco`);  // Redirection après succès
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            alert('Une erreur est survenue, réessayez plus tard.');  // Affiche une alerte à l'utilisateur
        }


    };

    const handleCancel = () => {
        window.location.reload(); // Recharge la page après l'annulation
    };

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 7000);
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');
  
    const verifGroupe = async () => {
      const groupeStored = localStorage.getItem('groupe');
      const accesGroupeStored = localStorage.getItem('accesGroupe');
  
      if (groupeStored && accesGroupeStored) {
        setGroupeId(groupeStored);
        setAccesGroupe(JSON.parse(accesGroupeStored));
      } else {
        try {
          const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
          if (response.status === 200) {
            const data = response.data;
            setGroupeId(data.groupe);
  
            let cleanedAccessArray = [];
            if (Array.isArray(data.acces)) {
              cleanedAccessArray = data.acces.map((item) =>
                item.acces
                  ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                  : []
              ).flat();
  
              setAccesGroupe(cleanedAccessArray);
            }
  
            localStorage.setItem('groupe', data.groupe);
            localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
          }
        } catch (error) {
          // console.error('Erreur lors de la vérification du groupe', error);
        }
      }
    };
  
    useEffect(() => {
      if (user_id) {
        verifGroupe();
      }
    }, [user_id]);
  
    if (!accesGroupe.includes("QCM")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="mr-2"><i className="fa fa-th fa-1x mr-2"></i>Nouvel éco </h2>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Liste-eco`}> Ecos</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Ajouter-eco`}> Nouvel éco</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                            {alert.message && (
                                <div className={`mt-2 alert alert-${alert.type}`}>
                                    {alert.message}
                                </div>
                            )}

                    <div className="row">
                        <div className="col-lg-2"></div>
                        <div className="col-lg-8">
                            <form className="" role="form" onSubmit={handleSubmit} encType="multipart/form-data">
                                <div className="ibox " style={{ paddingTop: "30px" }}>
                                    <div className="ibox-title">
                                        <h5>Ajouter un nouvel éco</h5>
                                    </div>
                                    <div className="ibox-content">

                                        <div className='row'>
                                            <div className="col-lg-6">

                                                <div className="ibox-title">
                                                    <h5>Version francaise</h5>
                                                </div>
                                                <div className="ibox-content">
                                                    {/* Colonne gauche - Français */}
                                                    <div className="hpanel">
                                                        <div className="panel-body">
                                                            <div className="form-group">
                                                                <label>Titre<span style={{ color: 'red' }}>*</span></label>
                                                                <input type="text" className="form-control" placeholder="" required name="titre_fr" />
                                                            </div>
                                                            <div className="form-group">
                                                                <label>Description</label>
                                                                <textarea className="form-control" placeholder="" name="description_fr" rows="5" />
                                                            </div>
                                                            <div className="form-group">
                                                                <label>Ordre<span style={{ color: 'red' }}>*</span></label>
                                                                <input type="number" className="form-control" placeholder="" required name="ordre_fr" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="col-lg-6">

                                                <div className="ibox-title">
                                                    <h5>Version anglaise</h5>
                                                </div>
                                                <div className="ibox-content">
                                                    {/* Colonne droite - Anglais */}
                                                    <div className="hpanel">
                                                        <div className="panel-body">
                                                            <div className="form-group">
                                                                <label>Title<span style={{ color: 'red' }}>*</span></label>
                                                                <input type="text" className="form-control" placeholder="" required name="titre_en" />
                                                            </div>
                                                            <div className="form-group">
                                                                <label>Description</label>
                                                                <textarea className="form-control" placeholder="" name="description_en" rows="5" />
                                                            </div>
                                                            <div className="form-group">
                                                                <label>Order<span style={{ color: 'red' }}>*</span></label>
                                                                <input type="number" className="form-control" placeholder="" required name="ordre_en" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                    <div className="ibox-footer">
                                        <div className="p-2 d-flex justify-content-end align-items-center">
                                            <button type="button" className="btn btn-default mr-2" onClick={handleCancel}>Annuler</button>
                                            <button type="submit" className="btn btn-success">Enregistrer</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}

export default Ajouter_eco;
